module.exports = __webpack_public_path__ + "img/ms.fd06d68d.svg";